import Vue from 'vue';

export function setCommunities(state, value) {
  state.communities = value;
}

export function setCommunityAttribute(state, payload) {
  const { index, field, value } = payload;
  const community = state.communities[index];
  community[field] = value;
  Vue.set(state.communities, index, community);
}

export function setFilter(state, payload) {
  const { field, value } = payload;
  state.filters[field] = value;
}
